import { useState } from "react";
import { FormControl, InputGroup } from "react-bootstrap";

import Picker from "emoji-picker-react";

import SetState from "../typings/SetState";
import ButtonComponent from "./ButtonComponent";

type InputComponentProps = {
  size?: any;
  disabled?: boolean;
  hideSendButton?: boolean;
  hideMultiMessageButton?: boolean;
  value: string;
  setValue: SetState<string>;
  setMultiMessageModal?: SetState<boolean>;
  onSubmitHandler?: (e: React.SyntheticEvent) => void;
};

const InputComponent = ({
  size,
  disabled,
  hideSendButton,
  hideMultiMessageButton,
  value,
  setValue,
  setMultiMessageModal,
  onSubmitHandler,
}: InputComponentProps) => {
  const [showPicker, setShowPicker] = useState(false);

  const onEmojiClick = (_event: any, emojiObject: any) => {
    setValue((curr) => curr + emojiObject.emoji);
    setShowPicker(!showPicker);
  };

  return (
    <InputGroup
      as="form"
      onSubmit={(e: React.SyntheticEvent) => onSubmitHandler?.(e)}
      size={size}
    >
      <div className="emoji">
        {showPicker ? (
          <Picker
            pickerStyle={{
              flexDirection: "column-reverse",
              position: "absolute",
              bottom: "3.2rem",
            }}
            onEmojiClick={onEmojiClick}
          />
        ) : null}
        <ButtonComponent
          data-testid="emoji-button"
          size={size}
          style={{}}
          disabled={disabled}
          onClick={() => {
            setShowPicker(!showPicker);
          }}
          variant="outline-secondary"
        >
          <i className="far fa-smile"></i>
        </ButtonComponent>
      </div>
      <FormControl
        disabled={disabled}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={
          disabled ? "select a channel..." : "insert your message..."
        }
      />
      {onSubmitHandler && (
        <>
          <ButtonComponent
            data-testid="multi-message-button"
            disabled={disabled}
            hidden={hideMultiMessageButton}
            onClick={() => setMultiMessageModal?.(true)}
            variant="outline-secondary"
          >
            <i className="fas fa-plus"></i>
          </ButtonComponent>
          <ButtonComponent
            data-testid="send-message-button"
            type="submit"
            disabled={disabled || value.length === 0}
            onClick={(e) => onSubmitHandler(e)}
            hidden={hideSendButton}
            variant="outline-secondary"
          >
            <i className="fas fa-paper-plane"></i>
          </ButtonComponent>
        </>
      )}
    </InputGroup>
  );
};

export default InputComponent;
